<template>
  <div>
    <div class="mt-2 bg-secondary-1 p-4">
      <div class="row bg-white py-2 rounded">
        <div class="col-3">
          <div class="info-text-title text-gray">
            <i class="fas fa-calendar-edit color-orange" />
            Año Académico:
          </div>
          <span>{{ value.academicYear }}</span>
        </div>
        <div class="col-3">
          <div class="info-text-title text-gray">
            <i class="fas fa-map-marker-alt color-orange" />
            Región:
          </div>
          <span>{{ value.region }}</span>
        </div>
        <div class="col-3">
          <div class="info-text-title text-gray">
            <i class="fas fa-map-marker-alt color-orange" />
            Municipio:
          </div>
          <span>{{ value.municipality }}</span>
        </div>
        <div class="col-3">
          <div class="info-text-title text-gray">
            <i class="fas fa-address-book color-orange" />
            Escuela:
          </div>
          <span>{{ value.school }}</span>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-6">
          <div class="info-text-title text-gray">
            Total de Maestros:
          </div>
          <span>{{ value.teacherCount || "-" }}</span>
        </div>
        <div class="col-6">
          <div class="info-text-title text-gray">
            Total de Asistentes:
          </div>
          <span>{{ value.assistantTotals || "-" }}</span>
        </div>
      </div>
    </div>
    <div class="bg-white mt-4">
      <CustomCallout
        v-for="(teacher, index) in value.teachers"
        :key="index"
        class="mt-2 py-2 deep"
        :has-toggle="true"
        :has-border="false"
      >
        <template #default>
          <div class="row bg-secondary-1 mb-2 mr-2 py-2">
            <div class="col-2 text-center align-self-center">
              <i class="fa-stack icon-circle p-2">
                <i
                  class="fas fa-circle fa-stack-2x icon-circle-stack color-orange"
                />
                <i class="fas fa-user fa-stack-1x fa-inverse" />
              </i>
            </div>
            <div class="col-4">
              <div class="info-text-title text-gray">
                Nombre del Maestro:
              </div>
              <span>{{ teacher.teacherName }}</span>
            </div>
            <div class="col-4">
              <div class="info-text-title text-gray">
                Nombre de Alternativa (Ruta):
              </div>
              <span>{{ teacher.alternativeRoute }}</span>
            </div>
          </div>
        </template>
        <template #edition>
          <div class="p-2">
            <div
              v-for="student in teacher.students"
              :key="student.studentSie"              
            >
              <div
                v-for="studentInfo in student.assistantStudentInfo"   
                :key="studentInfo.assistantId"                   
                class="bg-secondary-1 px-4"
              >
                <div class="row bg-white mt-3 px-2 py-3 rounded">
                  <div class="col-3">
                    <div class="info-text-title text-gray">
                      Nombre del Asistente:
                    </div>
                    <span>{{ studentInfo.assistantName || "-" }}</span>
                  </div>
                  <div class="col-3">
                    <div class="info-text-title text-gray">
                      Tipo de Asistente:
                    </div>
                    <span>{{ studentInfo.assistantType || "-" }}</span>
                  </div>
                  <div class="col-3">
                    <div class="info-text-title text-gray">
                      Tipo de Solicitud:
                    </div>
                    <span>{{ studentInfo.requestType || "-" }}</span>
                  </div>
                  <div class="col-3">
                    <div class="info-text-title text-gray">
                      Nombre del Estudiante:
                    </div>
                    <span>{{ student.studentName || "-" }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </CustomCallout>
    </div>
  </div>
</template>

<script>
import CustomCallout from "custom-callout";

export default {
  name: "TeacherSaeeInfo",
  components: {
    CustomCallout
  },
  props: {
    value: {
      type: Object,
      required: true
    }
  }
};
</script>
